export const ELF = {
    init: () => {
        const widget = document.querySelector('.eapps-instagram-feed, [class*="elfsight-app-"]');
        if (!widget) return;

        const forceRecalc = () => {
            window.dispatchEvent(new Event('resize'));
        };

        [300, 800, 1500].forEach(delay => setTimeout(forceRecalc, delay));

        if ('ResizeObserver' in window) {
            const parent = widget.parentElement;
            if (parent) {
                let lastWidth = parent.offsetWidth;
                const ro = new ResizeObserver(entries => {
                    const newWidth = entries[0].contentRect.width;
                    if (Math.abs(newWidth - lastWidth) > 2) {
                        lastWidth = newWidth;
                        forceRecalc();
                    }
                });
                ro.observe(parent);
            }
        }

        if (window.matchMedia) {
            window.matchMedia('(max-width: 1025px)').addEventListener('change', forceRecalc);
        }
    }
};